import { buildPath } from 'common/extensibility/AddinContainer';

export const PATH_ENVIRONMENT_PAGE = 'environment';
export const PATH_GCP_ENVIRONMENT = buildPath(PATH_ENVIRONMENT_PAGE, 'gcpEnvironment');
export const PATH_ENVIRONMENT_PAGE_GCP_DETAILS_PANEL = buildPath(PATH_GCP_ENVIRONMENT, 'detailsPanel');
export const PATH_ENVIRONMENT_PAGE_GCP_TAB = buildPath(PATH_GCP_ENVIRONMENT, 'tab');
export const PATH_ENVIRONMENT_PAGE_GCP_CHIP = buildPath(PATH_GCP_ENVIRONMENT, 'chip');
export const PATH_ENVIRONMENT_PAGE_ACTION = buildPath(PATH_GCP_ENVIRONMENT, 'action');

export interface GcpEnvironmentData {
    account: GcpCloudAccount;
}

export interface GcpCloudAccount {
    id: string;
    vendor: string;
    name: string;
    projectId: string;
    projectNumber: string;
    externalAccountNumber: string;
    error: string;
    isFetchingSuspended: boolean;
    creationDate: string;
    credentials: CloudAccountCredentials;
    organizationalUnitId?: any;
    organizationalUnitPath: string;
    organizationalUnitName: string;
    totalAssets: number;
    isServerlessActive: boolean;
    isCloudbotsOnboarded?: boolean;
    clientEmail?: string;
}

interface CloudAccountCredentials {
    clientId: string;
    clientPassword?: string;
}

export interface ServerlessGcpAccountStatesGetResponse {
    cloudAccountId: string;
    externalAccountNumber: string;
    cloudVendor: string;
    state: string;
    accountId: number;
    reason: string;
    shouldUpdate: boolean;
    isOrgOnboarding: boolean;
    hasMissingPermissions: boolean;
    validatePermissionsStatus: string;
    lastValidatePermissionsTimestamp: number;
}
